import constants from 'mimosa:constants';

export const MSConstant = constants;
